<div class="station-details">
  <sc-padding fitHeight>
    <sc-flex vertical fitHeight stretchContent *ngIf="station != null">
      <sc-flex-fitting-content vertical>
        <sc-loading-spinner [isLoading]="isLoading" fitHeight>

          <ng-container *ngIf="stationDetailsView === stationDetailsViewValues.STATION_DISABLED">
            <sc-padding [double]="true">
              <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.station-transport-details.station-disabled"></sc-dictionary-label>
            </sc-padding>
            <sc-flex stretchContent>
              <sc-content-spacer grow></sc-content-spacer>
              <sc-icon iconClass="fa-lock-open" (click)="endSuspension()"
                *ngIf="station.stationUsage.suspended"></sc-icon>
            </sc-flex>
          </ng-container>

          <ng-container *ngIf="stationDetailsView !== stationDetailsViewValues.STATION_DISABLED">
            <!-- <ng-container *ngIf="showTransportDetails"> -->
            <div class="transport-details" [ngClass]="{'ongoing-movement': station.stationUsage.ongoingMovementFromStation || station.stationUsage.ongoingMovementToStation}">
              <sc-flex vertical fitHeight stretchContent >
                <div class="header" *ngIf="showHeader">
                   <!-- BEGIN: HEADER -->
                   <div *ngIf="stationDetailsView === stationDetailsViewValues.ONGOING_MOVEMENT_ORDER_TO_STATION">
                    <sc-padding>
                      <div class="title">
                        <sc-icon iconClass="fa-truck-flatbed"></sc-icon>
                        <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.station-transport-details.ongoingMovement"></sc-dictionary-label>
                      </div>
                    </sc-padding>
                    <sc-content-spacer [double]="true" vertical></sc-content-spacer>
                  </div>

                  <div *ngIf="stationDetailsView === stationDetailsViewValues.ONGOING_MOVEMENT_ORDER_FROM_STATION">
                    <div class="title">
                      <sc-flex stretchContent centered>
                        <app-transport-scope-icon [scope]="transportDetails?.scope"></app-transport-scope-icon>
                        <sc-content-spacer></sc-content-spacer>
                        <ng-container *ngIf="transportDetails?.scope === 'SWAP_TRAILER'">
                          <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.station-transport-details.occupied-ongoingMovement-swaptrailer"></sc-dictionary-label>
                        </ng-container>
                        <ng-container *ngIf="transportDetails?.scope === 'TRAILER'">
                          <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.station-transport-details.occupied-ongoingMovement-trailer"></sc-dictionary-label>
                        </ng-container>
                        <ng-container
                          *ngIf="transportDetails?.scope === 'TRAIN' || transportDetails?.scope === 'SEMI_TRAILER_TRUCK'">
                          <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.station-transport-details.occupied-ongoingMovement-others"></sc-dictionary-label>
                        </ng-container>

                      </sc-flex>
                    </div>
                    <sc-content-spacer [double]="true" vertical></sc-content-spacer>
                  </div>

                  <div
                    *ngIf="stationDetailsView === stationDetailsViewValues.STATION_OCCUPIED">
                    <div class="title occupied">
                      <sc-flex  stretchContent centered>
                        <app-transport-scope-icon [scope]="transportDetails?.scope"></app-transport-scope-icon>
                        <ng-container *ngIf="transportDetails?.scope === 'SWAP_TRAILER'">
                          <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.station-transport-details.occupied-ongoingMovement-swaptrailer"></sc-dictionary-label>
                        </ng-container>
                        <ng-container *ngIf="transportDetails?.scope === 'TRAILER'">
                          <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.station-transport-details.occupied-ongoingMovement-trailer"></sc-dictionary-label>
                        </ng-container>
                        <ng-container
                          *ngIf="transportDetails?.scope === 'TRAIN' || transportDetails?.scope === 'SEMI_TRAILER_TRUCK'">
                          <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.station-transport-details.occupied-ongoingMovement-others"></sc-dictionary-label>
                        </ng-container>
                      </sc-flex>
                    </div>
                    <sc-content-spacer [double]="true" vertical></sc-content-spacer>
                  </div>
                  <!-- END: HEADER -->
                </div>
                <sc-flex-fitting-content vertical>
                  <div>
                    <sc-scroll-pane>


                      <ng-container *ngIf="showTransportDetails">
                        <sc-padding>
                          <app-transport-details [mode]="TransportDetailMode.READONLY" [layout]="layoutDefinition"
                            [transport]="transportDetails">
                          </app-transport-details>
                        </sc-padding>
                      </ng-container>

                      <div *ngIf="!showTransportDetails">
                        <sc-flex [wrap]="true">
                          <app-action-tablet-transport-creation-profile-details [stationId]="stationId"
                            [transportCreationProfile]="reference"
                            *ngFor="let reference of transportCreationProfiles"></app-action-tablet-transport-creation-profile-details>
                        </sc-flex>
                      </div>

                    </sc-scroll-pane>
                  </div>
                </sc-flex-fitting-content>

                <div>
                  <sc-content-spacer vertical></sc-content-spacer>
                  <app-action-tablet-buttonbar [station]="station" [transportDetails]="transportDetails"
                    [defaultCompletionOption]="defaultCompletionOption"></app-action-tablet-buttonbar>
                </div>
              </sc-flex>
            </div>
            <!-- </ng-container> -->




            <sc-content-spacer vertical></sc-content-spacer>
            <sc-flex stretchContent>
              <sc-content-spacer grow></sc-content-spacer>
              <sc-icon iconClass="fa-lock" (click)="startSuspension()"
                *ngIf="station.stationUsage.transports.length === 0 && !station.stationUsage.disabled && !station.stationUsage.loadingZoneLock"></sc-icon>
            </sc-flex>
          </ng-container>
        </sc-loading-spinner>
      </sc-flex-fitting-content>
    </sc-flex>
  </sc-padding>
